/**
 *
 * @param value Object to be test
 * @param id object key
 * @return T type
 */
export default function isThisType<T>(value: unknown, id: string): value is T {
  return value.hasOwnProperty(id)
}
